/** Иконки категорий: контур 24×24, обводка 2, круглые концы.
 *
 * Одно правило на весь набор — так набор читается как набор, а не как коллекция
 * случайных картинок. Рисуются в кружке цвета своей категории (стиль C из
 * бренд-бука): в списке иконка и так сидит в кружке, и подложка даёт цвет
 * бесплатно.
 *
 * РИСУНОК ЗАНИМАЕТ ВЕСЬ КВАДРАТ. Прежний набор жил в 16 единицах из 24 и при
 * 45% от кружка давал глиф в 15 пикселей — читалось как точка в пустом круге.
 * Теперь контур идёт от края до края (19–21 единица), а кружок отдаёт глифу
 * 56% (`CategoryIcon`). Рисуя новый значок, держи этот же размер: один мелкий
 * выбьется из строки заметнее, чем кажется.
 *
 * В чате остаются эмодзи — Telegram в тексте сообщения рисует только их. Одна и
 * та же категория будет 🍽 в чате и контурной вилкой здесь; это данность, а не
 * недоделка.
 */
const ICONS: Record<string, string[]> = {
  "еда/кафе": [
    "M2 2.5 V7.5 C2 10 3.5 11.5 5.5 11.5 C7.5 11.5 9 10 9 7.5 V2.5",
    "M5.5 2.5 V7.5",
    "M5.5 11.5 V21.5",
    "M20.5 21.5 V2.5 C18.2 5 17.5 9 18.3 12 H20.5",
  ],
  продукты: [
    "M7.5 8 C7.5 3.5 9.5 2 12 2 C14.5 2 16.5 3.5 16.5 8",
    "M2.5 8 H21.5 L19 21 H5 Z",
    "M9.5 12 V17",
    "M14.5 12 V17",
  ],
  транспорт: [
    "M5.6 14.8 A3.5 3.5 0 1 0 5.6 21.8 A3.5 3.5 0 1 0 5.6 14.8 Z",
    "M18.4 14.8 A3.5 3.5 0 1 0 18.4 21.8 A3.5 3.5 0 1 0 18.4 14.8 Z",
    "M2.6 12.8 V9.8 H10.5 C12.7 9.8 13.4 12.8 14.2 15.6 H8.6",
    "M14.2 15.6 L17 5.2",
    "M18.4 18.3 L17 5.2",
    "M13.9 4.6 H20.4",
  ],
  "жильё/аренда": [
    "M2 10.5 L12 2.5 L22 10.5",
    "M4.5 8.5 V21.5 H19.5 V8.5",
    "M9.5 21.5 V14.5 H14.5 V21.5",
  ],
  "связь/интернет": [
    // Дуги — четверти одной окружности с общим центром (12, 18.6), а не
    // полукольца: при хорде во всю ширину дуга поднимается почти на радиус, и
    // значок вытягивался радугой вместо веера.
    "M2.6 9.2 A13.3 13.3 0 0 1 21.4 9.2",
    "M5.78 12.38 A8.8 8.8 0 0 1 18.22 12.38",
    "M9.03 15.63 A4.2 4.2 0 0 1 14.97 15.63",
    "M12 18.6 h0.01",
  ],
  подписки: [
    "M2.5 12 A9.5 9.5 0 0 1 20.5 7.5",
    "M20.5 2.5 V7.5 H15.5",
    "M21.5 12 A9.5 9.5 0 0 1 3.5 16.5",
    "M3.5 21.5 V16.5 H8.5",
  ],
  здоровье: [
    "M12 21.5 L3.5 13 C1.5 11 1.5 7.5 3.5 5.5 C5.5 3.5 9 3.5 11 5.5 L12 6.5 L13 5.5 C15 3.5 18.5 3.5 20.5 5.5 C22.5 7.5 22.5 11 20.5 13 Z",
    "M6.5 11.5 H9.5 L11 8.5 L13 14 L14.5 11.5 H17.5",
  ],
  одежда: [
    "M8.5 2.5 L4 4.5 L2 9.5 L5.5 11 V21.5 H18.5 V11 L22 9.5 L20 4.5 L15.5 2.5 C15.5 2.5 14.5 5.5 12 5.5 C9.5 5.5 8.5 2.5 8.5 2.5 Z",
  ],
  развлечения: [
    "M2 4.5 H14 A2.2 2.2 0 0 0 18.4 4.5 H22 V19.5 H18.4 A2.2 2.2 0 0 0 14 19.5 H2 Z",
    "M16.2 8.8 V11.2",
    "M16.2 12.8 V15.2",
  ],
  путешествия: [
    "M 19.71 2.5 C 20.51 2.99 19.66 5.53 18.28 7.73 L 16.9 9.93 L 20.93 19.19 L 19.82 20.95 L 14.25 13.79 L 11.49 18.2 L 12.67 22 L 9.58 18.72 L 5.27 17.37 L 9.2 16.77 L 11.96 12.36 L 3.07 10.49 L 4.18 8.72 L 14.26 8.28 L 15.64 6.08 C 17.01 3.87 18.92 2 19.71 2.5 Z",
  ],
  "быт/дом": [
    "M8 17 C8 14.5 3.5 14 3.5 10.5 A8.5 8.5 0 0 1 20.5 10.5 C20.5 14 16 14.5 16 17 Z",
    "M9 19.5 H15",
    "M10.5 22 H13.5",
    "M12 17 V12.5",
    "M9.8 10.3 L12 12.5 L14.2 10.3",
  ],
  "переводы/люди": [
    "M 4.8 2.5 A 2.8 2.8 0 1 0 4.8 8.1 A 2.8 2.8 0 1 0 4.8 2.5 Z",
    "M1.6 12.5 C1.6 9.6 3 8.1 4.8 8.1 C6.6 8.1 8 9.6 8 12.5",
    "M 19.2 2.5 A 2.8 2.8 0 1 0 19.2 8.1 A 2.8 2.8 0 1 0 19.2 2.5 Z",
    "M16 12.5 C16 9.6 17.4 8.1 19.2 8.1 C21 8.1 22.4 9.6 22.4 12.5",
    "M2.5 18.5 H21.5",
    "M5.8 15.2 L2.5 18.5 L5.8 21.8",
    "M18.2 15.2 L21.5 18.5 L18.2 21.8",
  ],
  подарки: [
    "M2.5 7.5 H21.5 V11.5 H2.5 Z",
    "M4 11.5 V21.5 H20 V11.5",
    "M12 7.5 V21.5",
    "M12 7.5 C11 5 9.5 2.5 7.5 2.5 A2.5 2.5 0 1 0 7.5 7.5 H12",
    "M12 7.5 C13 5 14.5 2.5 16.5 2.5 A2.5 2.5 0 1 1 16.5 7.5 H12",
  ],
  прочее: [
    "M 12 2.5 A 9.5 9.5 0 1 0 12 21.5 A 9.5 9.5 0 1 0 12 2.5 Z",
    "M7.5 12 h0.01",
    "M12 12 h0.01",
    "M16.5 12 h0.01",
  ],

  // ── доходы ────────────────────────────────────────────────────────────────
  зарплата: [
    "M1.8 4.5 H17 V13 H1.8 Z",
    "M 9.4 6.65 A 2.1 2.1 0 1 0 9.4 10.85 A 2.1 2.1 0 1 0 9.4 6.65 Z",
    "M 17.8 13.3 A 4.2 4.2 0 1 0 17.8 21.7 A 4.2 4.2 0 1 0 17.8 13.3 Z",
  ],
  фриланс: [
    "M4.5 2.5 H19.5 V15.5 H4.5 Z",
    "M2 20.5 L4.5 15.5 H19.5 L22 20.5 Z",
  ],
  "крипто-доход": [
    "M 12 2.5 A 9.5 9.5 0 1 0 12 21.5 A 9.5 9.5 0 1 0 12 2.5 Z",
    "M10 7 V17",
    "M10 7 H13.6 C15.4 7 15.4 11.9 13.6 11.9 H10",
    "M10 11.9 H14.2 C16.2 11.9 16.2 17 14.2 17 H10",
    "M12.3 5 V7",
    "M12.3 17 V19",
  ],
  подарок: [
    "M2.5 9.5 H21.5 V21.5 H2.5 Z",
    "M12 9.5 C10.8 6.5 9 4 7 4 A2.75 2.75 0 1 0 7 9.5 H12",
    "M12 9.5 C13.2 6.5 15 4 17 4 A2.75 2.75 0 1 1 17 9.5 H12",
  ],
  продажа: [
    "M11.5 2.5 H4 A1.5 1.5 0 0 0 2.5 4 V11.5 A2 2 0 0 0 3.1 12.9 L11.1 20.9 A2.5 2.5 0 0 0 14.6 20.9 L20.9 14.6 A2.5 2.5 0 0 0 20.9 11.1 L12.9 3.1 A2 2 0 0 0 11.5 2.5 Z",
    "M 7 5.3 A 1.7 1.7 0 1 0 7 8.7 A 1.7 1.7 0 1 0 7 5.3 Z",
  ],
  "возврат долга": [
    "M16.75 3.8 A9.5 9.5 0 1 1 7.25 3.8",
    "M3.6 3.8 H7.25 V7.5",
    "M12 8.4 A3.6 3.6 0 1 0 12 15.6 A3.6 3.6 0 1 0 12 8.4 Z",
  ],
  "прочее (доход)": [
    "M12 2.5 A9.5 9.5 0 1 0 12 21.5 A9.5 9.5 0 1 0 12 2.5 Z",
    "M12 17 V7.5",
    "M8 11.5 L12 7.5 L16 11.5",
  ],

  // ── про запас ─────────────────────────────────────────────────────────────
  // Заводя свою категорию, человек выбирает значок отсюда (MA-FR-28). Набор не
  // случайный: это то, подо что реально заводят категории сверх сидовых.
  кофе: [
    "M4.5 9.5 H16.5 V13.5 C16.5 16.5 14.5 18.5 11.5 18.5 H9.5 C6.5 18.5 4.5 16.5 4.5 13.5 Z",
    "M16.5 11 H19 C20.8 11 21.5 12.2 21.5 13.5 C21.5 14.8 20.8 16 19 16 H16.5",
    "M2 21.5 H20",
    "M9.5 6.5 C8 5 11 3.5 9.5 2",
  ],
  бар: [
    "M2.5 4.5 H21.5 L12 14.5 Z",
    "M12 14.5 V21",
    "M6.5 21 H17.5",
    "M16.5 2 L13 7.5",
    "M 12.2 7.5 A 1.7 1.7 0 1 0 12.2 10.9 A 1.7 1.7 0 1 0 12.2 7.5 Z",
  ],
  "вредные привычки": [
    "M9.5 2 H14.5 L13.7 5.5 H10.3 Z",
    "M12 5.5 V13",
    "M7 8 H17",
    "M9.8 13 C7.2 14.3 5.5 16.3 5.5 18.3 C5.5 20.5 8.4 21.9 12 21.9 C15.6 21.9 18.5 20.5 18.5 18.3 C18.5 16.3 16.8 14.3 14.2 13 Z",
    "M12.4 9.9 C16.8 9.5 20.5 11.3 21.3 14 C21.9 15.9 21.3 17.5 19.8 18.5 L21.5 20.2",
  ],
  "цифровые товары": [
    "M2.5 3.5 H21.5 V17.5 H2.5 Z",
    "M12 17.5 V21.5",
    "M8 21.5 H16",
    "M12 7 V13.5",
    "M9 10.5 L12 13.5 L15 10.5",
  ],
  спорт: [
    "M8.7 15.3 L15.3 8.7",
    "M4 12 L12 20",
    "M2.7 15.7 L8.3 21.3",
    "M12 4 L20 12",
    "M15.7 2.7 L21.3 8.3",
  ],
  образование: [
    "M12 6.5 C10 4.5 7 3.5 2.5 3.5 V18 C7 18 10 19 12 21 C14 19 17 18 21.5 18 V3.5 C17 3.5 14 4.5 12 6.5 Z",
    "M12 6.5 V21",
  ],
  дети: [
    "M12 1.8 A8 7.9 0 1 0 12 17.6 A8 7.9 0 1 0 12 1.8 Z",
    "M10.3 17.4 L12 19.4 L13.7 17.4",
    "M12 19.4 C12 20.7 10.2 20.9 10.2 22",
  ],
  питомцы: [
    "M 4.8 6.8 A 2.4 2.4 0 1 0 4.8 11.6 A 2.4 2.4 0 1 0 4.8 6.8 Z",
    "M 9.5 2.9 A 2.4 2.4 0 1 0 9.5 7.7 A 2.4 2.4 0 1 0 9.5 2.9 Z",
    "M 14.5 2.9 A 2.4 2.4 0 1 0 14.5 7.7 A 2.4 2.4 0 1 0 14.5 2.9 Z",
    "M 19.2 6.8 A 2.4 2.4 0 1 0 19.2 11.6 A 2.4 2.4 0 1 0 19.2 6.8 Z",
    "M12 11.5 C8 11.5 5.5 14.5 5.5 17.5 C5.5 20.5 8 22 10 21 C11.3 20.4 12.7 20.4 14 21 C16 22 18.5 20.5 18.5 17.5 C18.5 14.5 16 11.5 12 11.5 Z",
  ],
  красота: [
    "M 5.5 2.2 A 3.3 3.3 0 1 0 5.5 8.8 A 3.3 3.3 0 1 0 5.5 2.2 Z",
    "M 5.5 15.2 A 3.3 3.3 0 1 0 5.5 21.8 A 3.3 3.3 0 1 0 5.5 15.2 Z",
    "M21 3.5 L8 16.5",
    "M8 7.5 L12 11.5",
    "M14.7 14.2 L21 20.5",
  ],
  мотобайк: [
    "M5.9 13.6 A3.9 3.9 0 1 0 5.9 21.4 A3.9 3.9 0 1 0 5.9 13.6 Z",
    "M18.1 13.6 A3.9 3.9 0 1 0 18.1 21.4 A3.9 3.9 0 1 0 18.1 13.6 Z",
    "M3.2 12.8 H8.2 L10 9.8 H13.8 L16.2 13.5 H9.5 L5.9 17.5 Z",
    "M18.1 17.5 L16 6.5",
    "M13.8 5.3 L18 7.2",
  ],
  аптека: [
    "M12 2.5 A9.5 9.5 0 1 0 12 21.5 A9.5 9.5 0 1 0 12 2.5 Z",
    "M12 7 V17",
    "M7 12 H17",
  ],
  ремонт: [
    "M14.7 6.3 A1 1 0 0 0 14.7 7.7 L16.3 9.3 A1 1 0 0 0 17.7 9.3 L21.5 5.5 A6 6 0 0 1 13.5 13.5 L6.6 20.4 A2.2 2.2 0 0 1 3.6 17.4 L10.5 10.5 A6 6 0 0 1 18.5 2.5 Z",
  ],
  техника: [
    "M2.5 3 H21.5 V16.5 H2.5 Z",
    "M10.2 20.5 L11 16.5 H13 L13.8 20.5 Z",
    "M6.5 20.5 H17.5",
  ],
  телефон: [
    "M6.5 2 H17.5 A1.8 1.8 0 0 1 19.3 3.8 V20.2 A1.8 1.8 0 0 1 17.5 22 H6.5 A1.8 1.8 0 0 1 4.7 20.2 V3.8 A1.8 1.8 0 0 1 6.5 2 Z",
    "M10.3 5.2 H13.7",
    "M10.3 18.8 H13.7",
  ],
  страховка: [
    "M12 2 L21 5.5 V12 C21 17 17 20.4 12 22 C7 20.4 3 17 3 12 V5.5 Z",
    "M8.3 12 L11 14.7 L15.7 9.5",
  ],
  налоги: [
    "M4 2.5 H20 V21.5 H4 Z",
    "M8.5 18 L15.5 10.5",
    "M9.2 10.3 A1.5 1.5 0 1 0 9.2 13.3 A1.5 1.5 0 1 0 9.2 10.3 Z",
    "M14.8 15.2 A1.5 1.5 0 1 0 14.8 18.2 A1.5 1.5 0 1 0 14.8 15.2 Z",
  ],
  банк: [
    "M2 9.5 L12 3 L22 9.5 Z",
    "M5.5 11.5 V20.5",
    "M12 11.5 V20.5",
    "M18.5 11.5 V20.5",
    "M2.5 20.5 H21.5",
  ],
  инвестиции: [
    "M2.5 20.5 L9 13 L13 17 L21.5 5.5",
    "M15 5.5 H21.5 V12",
  ],
  благотворительность: [
    "M3.5 15.5 C3.5 19.6 7.3 22 12 22 C16.7 22 20.5 19.6 20.5 15.5",
    "M12 12.8 L7.6 8.4 C6.6 7.4 6.6 5.6 7.6 4.6 C8.6 3.6 10.4 3.6 11.4 4.6 L12 5.2 L12.6 4.6 C13.6 3.6 15.4 3.6 16.4 4.6 C17.4 5.6 17.4 7.4 16.4 8.4 Z",
  ],
  документы: [
    "M4 2.5 H14 L20 8.5 V21.5 H4 Z",
    "M14 2.5 V8.5 H20",
    "M7.5 13.5 H16.5",
    "M7.5 17.5 H16.5",
  ],
  коммуналка: [
    "M6.5 3 C6.5 3 11 9 11 13.5 A4.5 4.5 0 0 1 2 13.5 C2 9 6.5 3 6.5 3 Z",
    "M17.6 2.5 L13 14 H17.2 L16.8 21.5 L21.3 10.5 H17.2 Z",
  ],
};

/** Запасная иконка: кошелёк. Своя категория без своей картинки — нормальное
 *  состояние, а не ошибка, и выглядеть должно спокойно. */
const FALLBACK = [
  "M2.5 7.5 H18 C19.9 7.5 21.5 9.1 21.5 11 V17 C21.5 18.9 19.9 20.5 18 20.5 H5 "
  + "C3.6 20.5 2.5 19.4 2.5 18 V7.5 Z",
  "M2.5 7.5 C2.5 5.8 3.8 4.5 5.5 4.5 H16",
  "M17 13.2 h1.6",
];

export function categoryPaths(name: string, icon?: string | null): string[] {
  // Выбранный значок побеждает подбор по имени: человек мог назвать категорию
  // «кофейни» — по имени такой картинки нет, а выбрать вилку он вправе.
  if (icon && icon in ICONS) return ICONS[icon]!;
  return ICONS[name.trim().toLowerCase()] ?? FALLBACK;
}

/** Ключи библиотеки — для сетки выбора значка. */
export const ICON_KEYS = Object.keys(ICONS);

/** Есть ли у категории своя иконка — нужно экрану управления, чтобы честно
 *  показать, что своей картинки пока нет. */
export function hasOwnIcon(name: string): boolean {
  return name.trim().toLowerCase() in ICONS;
}
